var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("" + (_vm.$route.name)), { notKorean: _vm.common.locale !== 'ko-KR' }]},[_c('header',{attrs:{"id":"header"}},[_c('NavArea')],1),_c('router-view'),_c('FooterArea')],1)}
var staticRenderFns = []

export { render, staticRenderFns }